
export default class ConferencesSlider {

	static getHolderSelectors = () => ['section.conferences-slider'];


	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		const slider = new Splide(holderElement.querySelector('.splide'), {
			arrows: false,
			fixedWidth: '27rem',
			fixedHeight: '28rem',
			focus: 'center',
			gap: '2.12rem',
			type: 'loop',
			drag: false,
			pagination: false,
		});
		slider.mount();

		const sliderArrows = holderElement.querySelectorAll('[data-slider-control]');
		sliderArrows.forEach(arrow => {
			arrow.addEventListener('click', () => {
				slider.go(arrow.dataset.sliderControl);
			});
		});



		let modalSlider = null;
		const galleryModal = document.querySelector('.gallery-modal');

		document.querySelectorAll('.gallery-modal-toggle').forEach(button => {
			button.addEventListener('click', () => {
				galleryModal.classList.toggle('open');

				const selector = `[data-conference="${button.dataset.conference}"]`;

				if (modalSlider) {
					modalSlider.destroy();
				}

				galleryModal.querySelectorAll('[data-conference]').forEach(slider => {
					if (slider.dataset.conference !== button.dataset.conference) {
						slider.classList.add('d-none');
					} else {
						slider.classList.remove('d-none');
					}
				});

				modalSlider = new Splide(galleryModal.querySelector(selector), {
					fixedWidth: '100vw',
					pagination: false,
					arrows: false,
					type: 'loop',
				}).mount();
			});
		});

		galleryModal.querySelectorAll('[data-slider-control]').forEach(sliderControl => {
			sliderControl.addEventListener('click', () => {
				if (modalSlider) {
					modalSlider.go(sliderControl.dataset.sliderControl);
				}
			});
		});

	}
}
